var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RadioGroup',{staticClass:"sl-radio-tag",attrs:{"value":_vm.value,"type":"button"},on:{"on-change":_vm.handleChange}},_vm._l((_vm.values),function(item){return _c('Radio',{attrs:{"label":item.value}},[_vm._v(_vm._s(item.label))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }